<template>
    <div class="login-page">
        <aside class="brand">
            <div class="brand-inner">
                <div class="mark" aria-hidden="true">
                    <span class="mark-v"></span>
                    <span class="mark-h"></span>
                </div>
                <p class="brand-kicker">Hospital Desk</p>
                <h1 class="brand-title">预约挂号<br />管理中心</h1>
                <p class="brand-desc">排班 · 预约 · 就诊运营</p>
            </div>
            <img class="brand-illust" src="../../images/u2669.svg" alt="" />
            <p class="brand-foot">内部管理系统 · 请妥善保管账号</p>
        </aside>

        <main class="panel">
            <img class="panel-illust" src="../../images/u2670.svg" alt="" />
            <div class="panel-inner">
                <header class="panel-head">
                    <h2>登录</h2>
                    <p>使用管理员账号进入后台</p>
                </header>

                <el-form
                    class="form"
                    :rules="rules"
                    ref="loginForm"
                    :model="user"
                    @keyup.enter.native="login"
                >
                    <label class="field-label">账号</label>
                    <el-form-item prop="username">
                        <el-input
                            v-model="user.username"
                            placeholder="请输入管理员账号"
                            clearable
                            autocomplete="username"
                        />
                    </el-form-item>

                    <label class="field-label">密码</label>
                    <el-form-item prop="password">
                        <el-input
                            v-model="user.password"
                            show-password
                            placeholder="请输入密码"
                            autocomplete="current-password"
                        />
                    </el-form-item>

                    <el-form-item class="submit-item">
                        <el-button class="submit-btn" :loading="submitting" @click="login">
                            进入系统
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            submitting: false,
            user: {
                username: '',
                password: '',
            },
            rules: {
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
        }
    },
    methods: {
        login() {
            this.$refs.loginForm.validate(async (valid) => {
                if (!valid) return
                this.submitting = true
                const loading = this.$loading({
                    lock: true,
                    text: '正在登录',
                    spinner: 'el-icon-loading',
                    background: 'rgba(15, 23, 42, 0.45)',
                })
                try {
                    const { data: res } = await this.$http.post('api/adminLogin', {
                        username: this.user.username,
                        password: this.user.password,
                    })
                    if (res.code == 200) {
                        this.$message.success('登录成功')
                        var timestamp = Math.round(new Date().getTime() / 1000).toString()
                        localStorage.setItem('tokenStartTime', timestamp)
                        localStorage.setItem('adminToken', 'Bearer ' + res.token)
                        localStorage.setItem('adminName', res.adminName)
                        this.$router.push('/home')
                    } else {
                        this.$message.error(res.msg)
                    }
                } finally {
                    loading.close()
                    this.submitting = false
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.login-page {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: #eef1f3;
    overflow: hidden;
    animation: pageIn 0.55s ease both;
}

.brand {
    position: relative;
    width: 42%;
    min-width: 320px;
    padding: 48px 56px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #f8fafc;
    background:
        linear-gradient(160deg, rgba(13, 148, 136, 0.18) 0%, transparent 42%),
        #1e293b;
    overflow: hidden;
}

.brand::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
        linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: linear-gradient(180deg, #000 0%, transparent 85%);
    pointer-events: none;
}

.brand-inner {
    position: relative;
    z-index: 2;
    margin-top: 8vh;
    animation: rise 0.7s 0.08s ease both;
}

.brand-illust {
    position: absolute;
    left: 50%;
    bottom: 56px;
    z-index: 1;
    width: min(42%, 200px);
    height: auto;
    transform: translateX(-50%);
    opacity: 0.92;
    pointer-events: none;
    animation: rise 0.8s 0.2s ease both;
    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.25));
}

.brand-foot {
    position: relative;
    z-index: 2;
    margin: 0;
    font-size: 12px;
    color: #64748b;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.panel {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 24px;
    box-sizing: border-box;
    background:
        radial-gradient(ellipse 70% 50% at 100% 0%, rgba(13, 148, 136, 0.06), transparent 55%),
        #eef1f3;
    overflow: hidden;
}

.panel-illust {
    position: absolute;
    right: max(2%, 12px);
    bottom: 0;
    z-index: 0;
    width: min(34%, 260px);
    height: auto;
    max-height: 78%;
    object-fit: contain;
    object-position: bottom right;
    opacity: 0.88;
    pointer-events: none;
    animation: rise 0.8s 0.28s ease both;
    filter: drop-shadow(0 10px 20px rgba(15, 23, 42, 0.08));
}

.panel-inner {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 360px;
    animation: rise 0.7s 0.16s ease both;
}

.mark {
    position: relative;
    width: 36px;
    height: 36px;
    margin-bottom: 28px;
}

.mark-v,
.mark-h {
    position: absolute;
    background: #2dd4bf;
    border-radius: 1px;
}

.mark-v {
    left: 50%;
    top: 0;
    width: 6px;
    height: 100%;
    transform: translateX(-50%);
}

.mark-h {
    top: 50%;
    left: 0;
    width: 100%;
    height: 6px;
    transform: translateY(-50%);
}

.brand-kicker {
    margin: 0 0 14px;
    font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
    font-size: 12px;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #94a3b8;
}

.brand-title {
    margin: 0;
    font-family: "Songti SC", "STSong", "SimSun", serif;
    font-weight: 600;
    font-size: 40px;
    line-height: 1.28;
    letter-spacing: 0.04em;
    color: #f8fafc;
}

.brand-desc {
    margin: 22px 0 0;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 14px;
    letter-spacing: 0.28em;
    color: #99f6e4;
}

.panel-head {
    margin-bottom: 36px;

    h2 {
        margin: 0;
        font-family: "Songti SC", "STSong", "SimSun", serif;
        font-size: 28px;
        font-weight: 600;
        color: #0f172a;
        letter-spacing: 0.06em;
    }

    p {
        margin: 10px 0 0;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 14px;
        color: #64748b;
    }
}

.field-label {
    display: block;
    margin: 0 0 8px;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 13px;
    color: #334155;
}

.form {
    /deep/ .el-form-item {
        margin-bottom: 22px;
    }

    /deep/ .el-input__inner {
        height: 46px;
        line-height: 46px;
        border-radius: 4px;
        border-color: #d5dbe3;
        background: #fff;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        color: #0f172a;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    /deep/ .el-input__inner:focus {
        border-color: #0d9488;
        box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.12);
    }

    /deep/ .el-form-item__error {
        padding-top: 4px;
    }
}

.submit-item {
    margin-top: 10px !important;
    margin-bottom: 0 !important;
}

.submit-btn {
    width: 100%;
    height: 46px;
    margin: 0 !important;
    border: none !important;
    border-radius: 4px !important;
    background: #0d9488 !important;
    color: #fff !important;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 15px;
    letter-spacing: 0.12em;
    transition: background 0.2s ease, transform 0.15s ease;
}

.submit-btn:hover,
.submit-btn:focus {
    background: #0f766e !important;
    color: #fff !important;
}

.submit-btn:active {
    transform: translateY(1px);
}

@keyframes pageIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes rise {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 900px) {
    .login-page {
        flex-direction: column;
    }

    .brand {
        width: 100%;
        min-width: 0;
        min-height: auto;
        padding: 28px 24px 32px;
    }

    .brand-inner {
        margin-top: 0;
    }

    .brand-title {
        font-size: 28px;
    }

    .brand-foot {
        display: none;
    }

    .brand-illust {
        display: none;
    }

    .panel-illust {
        width: min(42%, 180px);
        opacity: 0.55;
        right: 8px;
    }

    .panel {
        flex: 1;
        align-items: flex-start;
        padding-top: 36px;
    }
}
</style>
